import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';

import pricingPlans from '../../config/pricingPlans';
import DataService from '../../services/DataService';
import styles from './styles';

const Pricing = (props) => {
    const { classes } = props;

    const [plans, setPlans] = useState(pricingPlans.plans);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        DataService.GetUserAccessPlans()
            .then((response) => {
                setPlans(response.data?.plans?.length ? response.data.plans : pricingPlans.plans);
            })
            .catch(() => {
                setPlans(pricingPlans.plans);
            })
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className={classes.root}>
            <Container maxWidth="lg">
                <Typography variant="h4" component="h1" className={classes.title} align="center">
                    Pricing for PINN Hub
                </Typography>
                <Typography variant="body1" align="center" className={classes.intro}>
                    Current plans map to the capabilities already in this repo: solver sharing, project collaboration, and access to the PINNs Agent. Broader multi-framework execution features are not live in the current release yet.
                </Typography>
                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" mt={4}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Grid container spacing={4} className={classes.gridContainer}>
                        {plans.map((plan) => (
                            <Grid item key={plan.id} xs={12} sm={6} md={4}>
                                <Card className={classes.card}>
                                    <CardContent>
                                        <Typography variant="h5" component="h2" className={classes.planName}>
                                            {plan.label}
                                        </Typography>
                                        <Typography variant="h4" component="p" className={classes.price}>
                                            ${plan.price}<span style={{ fontSize: '1rem' }}>/month</span>
                                        </Typography>
                                            <ul className={classes.featureList}>
                                                <li className={classes.feature}>
                                                {plan.daily_agent_message_limit === null
                                                    ? 'Unlimited PINNs Agent messages'
                                                    : `${plan.daily_agent_message_limit} PINNs Agent messages per day`}
                                                </li>
                                            <li className={classes.feature}>Solver uploads, downloads, and workspace access</li>
                                        </ul>
                                    </CardContent>
                                    <CardActions className={classes.cardActions}>
                                        <Button variant="contained" color="primary" fullWidth className={classes.actionButton}>
                                            Get Started
                                        </Button>
                                    </CardActions>
                                </Card>
                            </Grid>
                        ))}
                        <Grid item xs={12} sm={6} md={4}>
                            <Card className={classes.card}>
                                <CardContent>
                                    <Typography variant="h5" component="h2" className={classes.planName}>
                                        Enterprise
                                    </Typography>
                                    <Typography variant="h4" component="p" className={classes.price}>
                                        Custom
                                    </Typography>
                                    <ul className={classes.featureList}>
                                        <li className={classes.feature}>
                                            Pilot planning and migration support
                                        </li>
                                        <li className={classes.feature}>
                                            Private deployment guidance
                                        </li>
                                        <li className={classes.feature}>
                                            Integration scoping for future platform work
                                        </li>
                                    </ul>
                                </CardContent>
                                <CardActions className={classes.cardActions}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        href="mailto:nextgenaischool@gmail.com?subject=PINN%20Hub%20Enterprise"
                                        className={classes.actionButton}
                                    >
                                        Contact Us
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    </Grid>
                )}
            </Container>
        </div>
    );
};

export default withStyles(styles)(Pricing);
